export type TriggerIdType = number

export interface AutomationRuleTriggerInterface {
  id?: TriggerIdType
  type: AutomationRuleTriggersEnum
  buttonId?: string
  checkBoxId?: string
  formId?: string
  preventSaving?: boolean
}

// NOTE: This is the API response type
export interface AutomationRuleTriggerApiInterface {
  id: TriggerIdType
  type: AutomationRuleTriggersEnum
  buttonId: string | null
  checkBoxId: string | null
  funnelStep: {
    form: {
      id: string
      name: string
    }
  } | null
  website: {
    websitePage: {
      form: {
        id: string
        name: string
      }
    }
  } | null
}

export type TriggerKeyType = keyof Pick<
  AutomationRuleTriggerInterface,
  'buttonId' | 'checkBoxId' | 'formId'
>

export enum AutomationRuleTriggersEnum {
  form_subscribed = 'form_subscribed',
  blog_page_form_subscribed = 'blog_page_form_subscribed',
  website_form_subscribed = 'website_form_subscribed',
}
